import { render, staticRenderFns } from "./TelegramGroup.vue?vue&type=template&id=c0dde6be&"
import script from "./TelegramGroup.vue?vue&type=script&lang=ts&"
export * from "./TelegramGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TelegramGroup.vue"
export default component.exports